import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Image,
  __css,
  Text,
} from '@fluentui/react-components';
import { useEffect, useState } from 'react';

import mimecastLogo from '../assets/mimecast-m-white.png';

const useStyles = __css({"header":{"mc9l5x":"f22iagw","Brf1p80":"f1869bpl","Bt984gj":"f122n59","De3pzq":"f1dyx4of","sj55zd":"fmysjtr","Bqenvij":"fbhnoac","Byoj8tv":0,"uwmqm3":0,"z189sj":0,"z8tnut":0,"B0ocmuz":"f127wd93"},"logo":{"mc9l5x":"f22iagw","Bt984gj":"f122n59"},"logoImage":{"a9b677":"fwfqyga","Bqenvij":"fjamq6b"},"sessionInfo":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","i8kkvl":0,"Belr9w4":0,"rmohyg":"f1ga9sj3"}});

interface HeaderProps {
  expiration: number;
  onEndSession: () => void;
}

const formatTimeRemaining = (expiration: number) => {
  // expiration is in seconds, convert to ms
  const expiryTime = expiration * 1000;
  const diff = expiryTime - Date.now();

  if (diff <= 0) return '00:00';

  return new Intl.DateTimeFormat('en-GB', {
    hour: diff >= 3600000 ? '2-digit' : undefined,
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'UTC',
  }).format(diff);
};

const Header = ({ expiration, onEndSession }: HeaderProps) => {
  const styles = useStyles();
  const [timeRemaining, setTimeRemaining] = useState(
    formatTimeRemaining(expiration),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(formatTimeRemaining(expiration));
    }, 1000);

    return () => clearInterval(interval);
  }, [expiration]);

  return (
    <div className={styles.header}>
      <div className={styles.logo}>
        <Image
          className={styles.logoImage}
          fit="contain"
          src={mimecastLogo}
          alt="Logo"
        />
        <Text>Browser Isolation</Text>
      </div>
      <div className={styles.sessionInfo}>
        <Text>Time Remaining: {timeRemaining}</Text>
        <Dialog>
          <DialogTrigger disableButtonEnhancement>
            <Button size="small" shape="circular">
              <Text>End Session</Text>
            </Button>
          </DialogTrigger>
          <DialogSurface>
            <DialogBody>
              <DialogTitle>End Session?</DialogTitle>
              <DialogActions>
                <DialogTrigger disableButtonEnhancement>
                  <Button appearance="secondary">Cancel</Button>
                </DialogTrigger>
                <Button appearance="primary" onClick={onEndSession}>
                  End
                </Button>
              </DialogActions>
            </DialogBody>
          </DialogSurface>
        </Dialog>
      </div>
    </div>
  );
};

export default Header;


import "/usr/local/jenkins/workspace/BI_bi-frontend_2.2.3/src/components/Header.griffel.css";